import { faChartMixed } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Stack, Typography } from "@mui/material";
import { useTheme } from "styled-components";

interface NoGraphDataProps {
  title: string;
}

export const NoGraphData: React.FC<NoGraphDataProps> = ({ title }) => {
  const theme = useTheme();

  return (
    <Stack spacing={2} sx={{ alignItems: "center", justifyContent: "center" }}>
      <FontAwesomeIcon icon={faChartMixed} size="3x" color={theme.colors.redesign.db40} />
      <Typography variant="subtitle1" color={theme.colors.redesign.db40}>
        {title}
      </Typography>
    </Stack>
  );
};
